export default __webpack_public_path__ + "static/PFHD_2022-caa49aea7d80a3b53c55453353f47e69.pdf";